import React from 'react';

const PremiumStatusBadgeIcon = props => {
  const { width, height, className, specificLocators } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      data-locator={specificLocators}
      viewBox="0 0 71 20"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#000"
          d="M69 0c.424 0 .841.026 1.25.077C67.08 2.237 65 5.876 65 10s2.08 7.762 5.249 9.922c-.409.052-.826.078-1.249.078H10C4.477 20 0 15.523 0 10S4.477 0 10 0h59z"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M15.99 13h-1.323V7.67h-2.562V13h-1.318V6.602h5.203V13zm3.274-2.254V13h-1.318V6.602h2.496c.48 0 .903.087 1.267.263.365.176.646.426.842.75.196.323.294.692.294 1.105 0 .627-.214 1.121-.643 1.483-.43.362-1.024.543-1.782.543h-1.156zm0-1.068h1.178c.348 0 .614-.082.797-.246.183-.164.275-.399.275-.703 0-.314-.092-.567-.277-.76-.185-.194-.44-.294-.765-.3h-1.208v2.009zm9.136.55h-2.53v1.713h2.97V13h-4.29V6.602h4.281v1.067h-2.962v1.525H28.4v1.033zm3.736-3.626l1.643 4.64 1.635-4.64h1.732V13h-1.323v-1.749l.132-3.02L34.228 13h-.906L31.6 8.236l.132 3.015V13h-1.319V6.602h1.723zm10.797 0h1.323V13h-1.323V8.75L40.371 13h-1.318V6.602h1.318v4.258l2.562-4.258zm5.665 3.023l1.165-3.023h1.424l-2.237 5.277-.18.348c-.331.577-.838.865-1.52.865l-.462-.017-.014-1.06c.07.012.185.018.343.018.185 0 .333-.032.446-.096.113-.065.208-.184.284-.356l.162-.418-2.245-4.561h1.42l1.414 3.023zm5.806-3.023l1.643 4.64 1.635-4.64h1.731V13h-1.322v-1.749l.131-3.02L56.495 13h-.905l-1.723-4.764.132 3.015V13h-1.318V6.602h1.723z"
        />
      </g>
    </svg>
  );
};

PremiumStatusBadgeIcon.defaultProps = {
  width: 71,
  height: 20,
};

export default PremiumStatusBadgeIcon;
